<template>
  <header class="navbar">
    <div class="navbar-inner">
      <div class="navbar-start">
        <router-link class="navbar-brand" :to="{ name: 'home' }" @click="closeMenu">
          Tracks.multed.com
        </router-link>
        <nav class="navbar-nav" aria-label="Разделы">
          <router-link
            class="navbar-link"
            :class="{ 'navbar-link--active': isTracksSection }"
            :to="{ name: 'home' }"
            @click="closeMenu"
          >
            Треки
          </router-link>
          <router-link
            class="navbar-link"
            :class="{ 'navbar-link--active': isTripsSection }"
            :to="{ name: 'trips-home' }"
            @click="closeMenu"
          >
            Поездки
          </router-link>
          <router-link
            class="navbar-link"
            :class="{ 'navbar-link--active': isEventsSection }"
            :to="{ name: 'events-home' }"
            @click="closeMenu"
          >
            Календарь
          </router-link>
          <router-link
            class="navbar-link"
            :class="{ 'navbar-link--active': route.name === 'forum' }"
            :to="{ name: 'forum' }"
            @click="closeMenu"
          >
            Форум
          </router-link>
          <router-link
            class="navbar-link"
            :class="{ 'navbar-link--active': route.name === 'contacts' }"
            :to="{ name: 'contacts' }"
            @click="closeMenu"
          >
            Контакты
          </router-link>
        </nav>
      </div>

      <button
        class="navbar-toggle"
        type="button"
        :aria-expanded="menuOpen"
        aria-controls="navbar-menu"
        aria-label="Меню"
        @click="toggleMenu"
      >
        <span class="navbar-toggle-bar" />
        <span class="navbar-toggle-bar" />
        <span class="navbar-toggle-bar" />
      </button>

      <nav
        id="navbar-menu"
        class="navbar-menu"
        :class="{ 'navbar-menu--open': menuOpen }"
      >
        <div class="navbar-menu-section" aria-label="Разделы">
          <router-link
            class="navbar-link"
            :class="{ 'navbar-link--active': isTracksSection }"
            :to="{ name: 'home' }"
            @click="closeMenu"
          >
            Треки
          </router-link>
          <router-link
            class="navbar-link"
            :class="{ 'navbar-link--active': isTripsSection }"
            :to="{ name: 'trips-home' }"
            @click="closeMenu"
          >
            Поездки
          </router-link>
          <router-link
            class="navbar-link"
            :class="{ 'navbar-link--active': isEventsSection }"
            :to="{ name: 'events-home' }"
            @click="closeMenu"
          >
            Календарь
          </router-link>
          <router-link
            class="navbar-link"
            :class="{ 'navbar-link--active': route.name === 'forum' }"
            :to="{ name: 'forum' }"
            @click="closeMenu"
          >
            Форум
          </router-link>
          <router-link
            class="navbar-link"
            :class="{ 'navbar-link--active': route.name === 'contacts' }"
            :to="{ name: 'contacts' }"
            @click="closeMenu"
          >
            Контакты
          </router-link>
        </div>

        <template v-if="auth.isAuthenticated">
          <router-link
            v-if="auth.isAdmin"
            class="navbar-link"
            :class="{ 'navbar-link--active': isAdminSection }"
            :to="{ name: 'admin-users' }"
            @click="closeMenu"
          >
            Админ
          </router-link>
          <router-link
            class="navbar-link"
            :class="{ 'navbar-link--active': route.name === 'profile' }"
            :to="{ name: 'profile' }"
            @click="closeMenu"
          >
            Мой профиль
          </router-link>
          <router-link
            class="navbar-link"
            :class="{ 'navbar-link--active': route.name === 'notifications' }"
            :to="{ name: 'notifications' }"
            @click="closeMenu"
          >
            Уведомления
          </router-link>
          <button class="navbar-link navbar-link--button" type="button" @click="logout">
            Выйти
          </button>
        </template>
        <template v-else>
          <router-link
            class="navbar-link"
            :class="{ 'navbar-link--active': route.name === 'login' }"
            :to="{ name: 'login' }"
            @click="closeMenu"
          >
            Войти
          </router-link>
          <router-link
            class="navbar-link"
            :class="{ 'navbar-link--active': route.name === 'register' }"
            :to="{ name: 'register' }"
            @click="closeMenu"
          >
            Регистрация
          </router-link>
        </template>
      </nav>
    </div>
  </header>
</template>

<script setup>
import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '../stores/auth'

const TRACKS_ROUTE_NAMES = ['home', 'track', 'track-new', 'author-tracks', 'public-profile-tracks']
const TRIPS_ROUTE_NAMES = ['trips-home', 'trip', 'trip-new', 'trip-edit', 'author-trips', 'public-profile-trips']
const EVENTS_ROUTE_NAMES = ['events-home', 'event', 'event-new', 'event-edit', 'author-events', 'public-profile-events']
const ADMIN_ROUTE_NAMES = [
  'admin-users',
  'admin-tracks',
  'admin-trips',
  'admin-comments',
  'admin-moderation-actions',
]

const route = useRoute()
const router = useRouter()
const auth = useAuthStore()
const menuOpen = ref(false)

const isTracksSection = computed(() => TRACKS_ROUTE_NAMES.includes(route.name))
const isTripsSection = computed(() => TRIPS_ROUTE_NAMES.includes(route.name))
const isEventsSection = computed(() => EVENTS_ROUTE_NAMES.includes(route.name))
const isAdminSection = computed(() => ADMIN_ROUTE_NAMES.includes(route.name))

function toggleMenu() {
  menuOpen.value = !menuOpen.value
}

function closeMenu() {
  menuOpen.value = false
}

function onKeydown(event) {
  if (event.key === 'Escape') {
    closeMenu()
  }
}

async function logout() {
  closeMenu()
  await auth.logout()
  router.push({ name: 'home' })
}

watch(() => route.fullPath, closeMenu)

onMounted(() => {
  document.addEventListener('keydown', onKeydown)
})

onUnmounted(() => {
  document.removeEventListener('keydown', onKeydown)
})
</script>
